import FormContainer from './FormContainer';




const NotFound = props => {
       return  (
           <FormContainer>
               <h2>Page not found</h2>
               <p>Sorry, the page you requested could not be found. Please check the URL and try again.</p>
           </FormContainer>
       )
}

export default NotFound;